import {
  CashRegister,
  CashRegisterFormQuestions,
  CashRegisterOrder,
  CashRegisterHolder,
  CashRegisterSession,
  EventEntry,
} from "@ac-expo/api-types";
import { useQuery } from "@tanstack/react-query";
import { privateAxios } from "../axiosInstances";
import cashRegisterQueryKeys from "../query-keys/cash-register.query-keys";

const getCashRegisterEntries = async () => {
  const res = await privateAxios.get<EventEntry[]>(`/cash-register/entries`);
  return res.data;
};

export const useGetCashRegisterEntries = () => {
  return useQuery({
    queryKey: cashRegisterQueryKeys.entries(),
    queryFn: () => getCashRegisterEntries(),
  });
};

export const getCurrentCashRegisterHolder = async () => {
  const res = await privateAxios.get<CashRegisterHolder | null>(
    `/cash-register/me`
  );
  return res.data;
};

export const useGetCurrentCashRegisterHolder = () => {
  return useQuery({
    queryKey: cashRegisterQueryKeys.me(),
    queryFn: () => getCurrentCashRegisterHolder(),
  });
};

const getCurrentCashRegisterSession = async () => {
  const res = await privateAxios.get<CashRegisterSession | null>(
    `/cash-register/me/session`
  );
  return res.data;
};

export const useGetCurrentCashRegisterSession = () => {
  return useQuery({
    queryKey: cashRegisterQueryKeys.session(),
    queryFn: () => getCurrentCashRegisterSession(),
  });
};

const getCashRegisterFormQuestions = async () => {
  const res = await privateAxios.get<CashRegisterFormQuestions>(
    `/cash-register/form-questions`
  );
  return res.data;
};

export const useGetCashRegisterFormQuestions = () => {
  return useQuery({
    queryKey: cashRegisterQueryKeys.formQuestions(),
    queryFn: () => getCashRegisterFormQuestions(),
  });
};

const getHolderCashRegisters = async (): Promise<CashRegister[]> => {
  const res = await privateAxios.get<CashRegister[]>(
    `/cash-register/cash-registers`
  );
  return res.data;
};

export const useGetHolderCashRegisters = () => {
  return useQuery({
    queryKey: cashRegisterQueryKeys.cashRegisters(),
    queryFn: () => getHolderCashRegisters(),
  });
};

const getCashRegisterOrders = async (
  id: string
): Promise<CashRegisterOrder[]> => {
  const res = await privateAxios.get<CashRegisterOrder[]>(
    `/cash-register/${id}/orders`
  );
  return res.data;
};

export const useGetCashRegisterOrders = (id: string) => {
  return useQuery({
    queryKey: cashRegisterQueryKeys.commands(id),
    queryFn: () => getCashRegisterOrders(id),
  });
};

const getLastCashRegisterOrder = async (
  id: string
): Promise<CashRegisterOrder | null> => {
  const res = await privateAxios.get<CashRegisterOrder | null>(
    `/cash-register/${id}/orders/last`
  );
  return res.data;
};

export const useGetLastCashRegisterOrder = (id: string, enabled: boolean) => {
  return useQuery({
    queryKey: cashRegisterQueryKeys.lastCommand(id),
    queryFn: () => getLastCashRegisterOrder(id),
    enabled,
  });
};
